module.exports = __webpack_public_path__ + "img/JobInterview-1.b7c28428.svg";